import React from "react";
import {Col, Progress, Row, Spin} from "antd";
import {useFetchWithLoadingSmart} from "../../hooks/useFetch";
import CacheService from "../../services/CacheService";

export function DeferredRunInfoPages({projectId, runId}: {
    projectId: string,
    runId: string,
}) {
    const runInfo = useFetchWithLoadingSmart(
        () => CacheService.getRunVerbose(projectId, runId),
        [projectId, runId]
    );

    if (runInfo.status === "loading" || runInfo.status === "error") {
        return (
            <Spin spinning={true}>
                <small>{0}/{0}</small>
            </Spin>
        );
    } else {
        return (
            <small>{runInfo.data.processed_pages}/{runInfo.data.total_pages}</small>
        )
    }
}

export function DeferredRunInfoPollingStatus({projectId, runId}: {
    projectId: string,
    runId: string,
}) {
    const runInfo = useFetchWithLoadingSmart(
        () => CacheService.getRunVerbose(projectId, runId),
        [projectId, runId]
    );

    if (runInfo.status === "loading" || runInfo.status === "error") {
        return null;
    } else {
        const runData = runInfo.data;
        const percentage = (100.0 * runData.processed_pages / runData.total_pages).toFixed(1)
        return (
            <React.Fragment>
                <Row>
                    <Col span={5} style={{textAlign: 'right'}}>
                        {runData.processed_pages} / {runData.total_pages}
                    </Col>
                    <Col span={17} offset={1}>
                        <Progress percent={percentage as any} status="normal"/>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}